import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { AxiosError } from 'axios';
import { API } from 'network/api';

type AssignAgPayload = {
  reportingToUserEmailList: string[];
  email: string;
};

type AssignAgConfig = {
  onFinish: () => void;
};

const useUpdateAssignAg = (config: AssignAgConfig) => {
  const mutation = useMutation({
    mutationFn: (data: AssignAgPayload) =>
      API.put('/user/assign-reporting-manager', data),
    onSuccess: () => {
      message.success('Agronomist successfully reassigned');
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        message.error(error?.message);
      } else {
        message.error('Failed to reassign agronomist. Please try again');
      }
    },
    onSettled: config.onFinish,
  });

  return mutation;
};

export default useUpdateAssignAg;
